import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import {Icon} from "@iconify/react";
import { useRef } from "react";
import style from "./AddDepartment.module.css"
import { TbCircleNumber1 } from "react-icons/tb";
import {
  a100,
  a101,
  a102,
  a103,
  a104,
  a105,
  a106,
  a110,
  a18,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import { Box } from "@mui/material";
import Customertable from "Components/support/customervendor/customer";

export default function AddDepartmentNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
    const [searchInput, setSearchInput] = useState('');
  

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    DeptName: "",
    DeptCode: "",
    DeptHead: "",
    Description: "",
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;

  
  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };


  const handleList = () => {
    // Custom logic for the List button
    console.log("List button clicked");
    setActive("List");
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "DeptName", label: "Department Name", type: "read", priority: 1 },

    { key: "DeptCode", label: "Department Code", type: "read", priority: 3 },
    { key: "DeptHead", label: "Department Head", type: "read", priority: 4 },
    { key: "Description", label: "	Department Description", type: "read", priority: 5 },
   
  ];

  
  

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Branch First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  console.log(allBranchesList, "allBranchesList");
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const handleEditClick = (id) => {
    setEditingId(id);
    // Find the item with the selected ID and set its data in the state
    const selectedItem = allCategories.find((x) => x.id === id);
    setEditedData(selectedItem);
  };
  const fetchAllEmployees = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a110, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();

    try {
      if (data.length > 0) {
        setAllEmployees(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllEmployees();
  }, []);
  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");
  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      DeptName: newCategory.DeptName,
      DeptCode: newCategory.DeptCode,
      DeptHead: newCategory.DeptHead,
      Description: newCategory.Description,
      OldEntry: false,
      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a106 : a105,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        DeptName: "",
        DeptCode: "",
        DeptHead: "",
        Description: "",
        OldEntry: false,
      });
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.Message);
        setShowError(true);
        setActive("AddNew");
      } else {
        setMessageType("success");
        setMessageToShow("Department Added Successfully");
        setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };

  const inputRef1 = useRef(null);
      const inputRef2 = useRef(null);
      const inputRef3 = useRef(null);
      const inputRef4 = useRef(null);
      const inputRef5 = useRef(null);

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5
     
  ];


 
   

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };




  
  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };
  const handlenew = () => {
    setActive("AddNew");
  };

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Department"}
          companyName={"Loyalstring"}
          module={"User Masters"}
          page={"Department"}
        />
         </div>
         <div style={{ padding: "16px" }}>
        {active === "List" ? (
          <>
      <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     placeholder="Search..."
                     className={style["serach-input"]}
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                     onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>

            <Customertable
              columns={columns}
              allCategories={allCategories}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
        ) : (
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <form style={{ width: "100%" }} onSubmit={addNewCategory}>
                  <div
                    style={{
                      gridTemplateColumns: "repeat(4,2fr)",
                      columnGap: "30px",
                      margin: "0px 0px",
                      padding: "var(--Space-0, 0px) 24px",
                    }}
                    //   className="adminCategoryAddCategoryInnerBox"
                  >
                    <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      className={style.adminCategoryHeading}
                      id="adminInvoiceAddedCustomerEdit"
                    >
                      Add New Department
                    </h2>
                    {/* <Box sx={{ width: "95%", margin: "0 auto" }}>
                         <div
                        style={{
                            gridTemplateColumns: "repeat(4,1fr)",
                            columnGap: "40px",
                            margin: "15px 0px",
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                        >
                      <label>
                        Department Name <sup>*</sup>
                      </label>
                      <input
                        name="DeptName"
                        value={newCategory.DeptName}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        style={{border: '1px solid #ddd'}}
                      />
                      <label>
                        Department Code <sup>*</sup>
                      </label>
                      <input
                        name="DeptCode"
                        value={newCategory.DeptCode}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{border: '1px solid #ddd'}}
                      />
                      <label>
                        Department Head <sup>*</sup>
                      </label>

                      <select
                        name="DeptHead"
                        value={newCategory.DeptHead}
                        onChange={handleNewCategoryChange}
                        required="required"
                        
                      >
                        <option value="">Select an Employee</option>
                        {allEmployees.map((x, index) => (
                          <option
                            value={`${x.FirstName} ${x.LastName}`}
                          >{`${x.FirstName} ${x.LastName}`}</option>
                        ))}
                      </select>
                      <label>Department Description</label>
                      <input
                        name="Description"
                        value={newCategory.Description}
                        onChange={handleNewCategoryChange}
                        type="text"
                        style={{border: '1px solid #ddd'}}
                      />
                      </div>
                    </Box> */}
                    <Box sx={{ width: "95%", margin: "0 auto" }}>
  <div
    style={{
      gridTemplateColumns: "repeat(4,1fr)",
      columnGap: "40px",
      margin: "15px 0px",
    }}
    className="adminCategoryAddCategoryInnerBox"
  >
    <label>
      Department Name <sup>*</sup>
    </label>
    <input
      name="DeptName"
      value={newCategory.DeptName}
      onChange={handleNewCategoryChange}
      type="text"
      required="required"
      style={{ border: '1px solid #ddd' }}
      ref={inputRef1}
      onKeyDown={(e) => handleKeyPress(e, inputRef2)}
    />

    <label>
      Department Code <sup>*</sup>
    </label>
    <input
      name="DeptCode"
      value={newCategory.DeptCode}
      onChange={handleNewCategoryChange}
      type="number"
      style={{ border: '1px solid #ddd' }}
      ref={inputRef2}
      onKeyDown={(e) => handleKeyPress(e, inputRef3)}
    />

    <label>
      Department Head <sup>*</sup>
    </label>
    <select
      name="DeptHead"
      value={newCategory.DeptHead}
      onChange={handleNewCategoryChange}
      required="required"
      ref={inputRef3}
      onKeyDown={(e) => handleKeyPress(e, inputRef4)}
    >
      <option value="">Select an Employee</option>
      {allEmployees.map((x, index) => (
        <option
          key={index}
          value={`${x.FirstName} ${x.LastName}`}
        >{`${x.FirstName} ${x.LastName}`}</option>
      ))}
    </select>

    <label>Department Description</label>
    <input
      name="Description"
      value={newCategory.Description}
      onChange={handleNewCategoryChange}
      type="text"
      style={{ border: '1px solid #ddd' }}
      ref={inputRef4}
    />
  </div>
</Box>

                  </div>
                  {!loading ? 
                    <div className={style["btn-container"]}>
                    <button className={style.buttons} type="submit">
                      <Icon
                        icon="ic:baseline-check"
                        width="24"
                        height="24"
                      />{" "}
                      Submit
                    </button>
                    <button
                    
                      className={style.buttons}
                      style={{
                        backgroundColor: "#fff",
                        color: "#0077d4",
                        border: "1px solid #0077d4",
                      }}
                      type="button"
                      onClick={handleResetField}
                    >
                      <Icon
                        style={{ color: "#0077d4" }}
                        icon="ix:reset"
                        width="24"
                        height="24"
                      />
                      Reset
                    </button>
                    <button
                      className={style.buttons}
                      type="button"
                      onClick={handleList}
                    >
                      <Icon
                        icon="fluent:list-rtl-16-filled"
                        width="24"
                        height="24"
                      />
                      List
                    </button>
                  </div>
                   : null}
                </form>
              </div>
            </div>
          </div>
        )}
     
      </div>
    </div>
  );
}
